export default __webpack_public_path__ + "static/regga-signature-633be7a92d86cfe8adc993ad73affe80.png";